import { atom } from 'recoil'
import { IProjectCheckpoint } from 'screens/Admin/ProjectCheckpoints/projectCheckpoints.types'
import { IProjectStage, IProjectType } from 'screens/Admin/ProjectTypes/projectTypes.types'

interface IKnowleageBaseFiltersAtomState {
  projectTypeId: IProjectType['id'] | null
  projectStageId: IProjectStage['id']
  checkpointIds: IProjectCheckpoint['id'][]
  tagIds: []
  forMe: false
}

const knowleageBaseFiltersAtom = atom<IKnowleageBaseFiltersAtomState>({
  key: 'knowleage-base-filters',
  default: {
    projectTypeId: null,
    projectStageId: null,
    checkpointIds: [],
    tagIds: [],
    forMe: false,
  },
})
export default knowleageBaseFiltersAtom
